/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../../_chunks/dep-e43cf21c.js';
import React from 'react';
import useConfig from '../../hooks/useConfig.js';
import { useLocaleReceiver } from '../../locale/LocalReceiver.js';
import '../../_chunks/dep-2acfafca.js';
import '../../config-provider/ConfigContext.js';
import '../../_chunks/dep-46de7b2e.js';
import '../../_chunks/dep-d71ee5f3.js';
import '../../_chunks/dep-c3f1141e.js';
import '../../_chunks/dep-4b8f240e.js';
import '../../_chunks/dep-9acbc163.js';
import '../../_chunks/dep-7b52f080.js';
import '../../_chunks/dep-f10515e8.js';
import '../../_chunks/dep-4941ebe7.js';
import '../../_chunks/dep-e9b62d1f.js';
import '../../_chunks/dep-88cd50bf.js';
import '../../_chunks/dep-dcb5aa2a.js';
import '../../_chunks/dep-ee4bf8c2.js';
import '../../_chunks/dep-934eda0c.js';
import '../../_chunks/dep-7dce2c26.js';
import '../../_chunks/dep-12510d64.js';
import '../../_chunks/dep-6b568d83.js';
import '../../_chunks/dep-304e657b.js';
import '../../_chunks/dep-77e34309.js';
import '../../_chunks/dep-6506fbc2.js';
import '../../_chunks/dep-bb5d7b1e.js';
import '../../_chunks/dep-e285f2f8.js';
import '../../_chunks/dep-f4a320cd.js';
import '../../_chunks/dep-ec70b95c.js';
import '../../locale/zh_CN.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../../_chunks/dep-cbcc9f89.js';
import '../../_common/js/global-config/default-config.js';
import '../../config-provider/index.js';
import '../../config-provider/ConfigProvider.js';

function useTotal(props) {
  var _useLocaleReceiver = useLocaleReceiver("pagination"),
    _useLocaleReceiver2 = _slicedToArray(_useLocaleReceiver, 2),
    locale = _useLocaleReceiver2[0],
    t = _useLocaleReceiver2[1];
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var name = "".concat(classPrefix, "-pagination");
  var totalContent = props.totalContent,
    pageSize = props.pageSize,
    current = props.current,
    total = props.total;
  var totalContrl = null;
  if (totalContent === false) return {
    totalContrl: totalContrl
  };
  var renderTotalContent = function renderTotalContent() {
    if (typeof totalContent === "boolean") {
      return totalContent ? t(locale.total, {
        total: total
      }) : null;
    }
    if (typeof totalContent === "function") {
      var start = (current - 1) * pageSize;
      var end = Math.min(total, start + pageSize);
      return totalContent(total, [start + 1, end]);
    }
    return totalContent;
  };
  totalContrl = /* @__PURE__ */React.createElement("div", {
    className: "".concat(name, "__total")
  }, renderTotalContent());
  return {
    totalContrl: totalContrl
  };
}

export { useTotal as default };
//# sourceMappingURL=useTotal.js.map
